import { format, isValid, parseISO } from "date-fns";

function formatDate({ date, format: dateFormat }: { date?: string | null; format: string }) {
  if (!date) return "invalid date";
  const parsed = parseISO(date);
  // Prevents format() throwing a RangeError on an unparseable date.
  if (!isValid(parsed)) return "";
  return format(parsed, dateFormat);
}

export default formatDate;
